import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class BinderOptions extends RestApiModel {
  static getResourceEndpoint() {
    return '/BinderOptions';
  }
  
  static getBinderOptions(reportType, coverholder) {
    return api.get(this.getResourceEndpoint(), {
      params: {
        reportType,
        coverholder
      }
    });
  }
}

export default BinderOptions;
